<ng-container [ngSwitch]="status">
  <div *ngSwitchCase="0" class="status-pill none">NONE</div>
  <div *ngSwitchCase="1" class="status-pill succeeded">OK</div>
  <div *ngSwitchCase="2" class="status-pill pending">PENDING</div>
  <div
    *ngSwitchCase="3"
    class="status-pill processing"
    [ngStyle]="{
      background:
        'linear-gradient(to right, #00A9BE, #00A9BE ' +
        compositeProgressPercent +
        '%, #00A9BEAF ' +
        compositeProgressPercent +
        '%)',
    }"
  >
    PROCESSING
  </div>
  <div *ngSwitchCase="4" class="status-pill failed">FAILED</div>
  <div *ngSwitchCase="5" class="status-pill quarantined">QUARANTINED</div>
  <div *ngSwitchCase="6" class="status-pill clean">CLEAN</div>
  <div *ngSwitchCase="7" class="status-pill infected">INFECTED</div>
  <div *ngSwitchCase="8" class="status-pill scan_failed">SCAN FAILED</div>
</ng-container>
